export default __webpack_public_path__ + "static/media/Perfil-gerente.2a119581.png";